import { ref, computed } from 'vue';
import { language, nowLang } from '@/language';
import { useStore } from 'vuex';
const langSlideActive = ref(false); // 语言列表下拉状态
export default function () {
  const store = useStore();
  const langList = computed(() => store.state.survey.langList);
  const changeLang = lang => {
    language.setLang(lang);
  };
  const currentLanguage = computed(() => {
    return (
      langList.value.find(item => item.code === nowLang.value)?.name ||
      'English'
    );
  });
  return {
    langList,
    langSlideActive,
    changeLang,
    currentLanguage,
    nowLang
  };
}
